import {Translation} from "react-i18next";
import React from "react";

export const dayStartContractType = [
    {
        name: <Translation>
            {(t, {i18n}) => <span>{t("dayStartContractType.contractFirst")}</span>}
        </Translation>,
        contractTypeId: -1
    },
    {
        name: <Translation>
            {(t, {i18n}) => <span>{t("dayStartContractType.dayEntryOfPersonel")}</span>}
        </Translation>,
        contractTypeId: -2
    },
    {
        name: <Translation>
            {(t, {i18n}) => <span>{t("dayStartContractType.officialEntryDate")}</span>}
        </Translation>,
        contractTypeId: -3
    }
]